import { useInfiniteQuery } from 'react-query';

import { useAddress } from '../../providers/AddressProvider/AddressProvider';

import { getPaginatedDataResults, getPaginatedResultsTotalCount } from '../utils';
import { QueryKey } from '../query-keys';
import { isValidEthAddress } from '../../utils/address-utils';
import { NftsApi } from '../../api/NftsApi';

interface Props {
  params: {
    search: string;
    sortBy: string;
  };
}

export const useNftsByAddress = ({ params }: Props) => {
  const { search, sortBy } = params;
  const { address } = useAddress();

  const query: Partial<Record<'search' | 'sortBy' | 'pageKey', string>> = {};
  if (search) query.search = search;
  if (sortBy) query.sortBy = sortBy;

  const { data, ...rest } = useInfiniteQuery(
    QueryKey.Nfts(address!, search, sortBy),
    ({ pageParam = 1 }) =>
      NftsApi.getByAddress(address!, {
        page: pageParam,
        ...query,
      }),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: !!address && isValidEthAddress(address),
      getNextPageParam: (lastPage, allPages) => {
        const totalResultsFetched = getPaginatedResultsTotalCount(allPages);
        if (totalResultsFetched === lastPage.totalCount) return undefined;
        return lastPage.nextPage;
      },
    }
  );

  return {
    data,
    formattedData: data ? getPaginatedDataResults(data) : undefined,
    totalCount: data?.pages[0]?.totalCount,
    ...rest,
  };
};
